import styled from "styled-components"
import { Button } from "../../home/components/HeroSession.js/HeroSession.styles"
// import { BetaButton } from "../../home/components/OurProduct"

const KnowAbout = () => {
    return (
        <ContainerAbout>
            <Wrapper>
                <div>
                    <h2>You should know</h2>
                    <p>
                        What sets us apart is our ability to be part of our customer’s growth and transformation by providing them exciting investment offers and security on investments. <br /> <br />

                        We provide immediate response to all of our clients’ challenges and ensure they are resolved in the quickest time possible. We offer the best rates both for our loans and investments that gives our customers reasons to look forward to our offers. Technology is the core of our business and we are given to using technology in solving our clients’ day to day challenges.
                    </p>
                    {/* <BetaButton>
                        <DownloadBtn outline="outline" to="/product">Download Brochure</DownloadBtn>
                    </BetaButton> */}
                </div>
                <div>
                    <img src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651622525/invest-trust/Ellipse_26_v0vra4.png" alt="betalife" />
                </div>
            </Wrapper>
        </ContainerAbout>
    )
}

export default KnowAbout

export const ContainerAbout = styled.div`
  background-image: url("https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651623504/invest-trust/Component_1_2_wvgtuc.png");
  background-repeat: no-repeat;
  background-position: left;
  background-color: #dbdbf9;
  // background-size: cover;
  @media screen and (max-width: 991px) {
    background-position: right;
  }
`;

export const Wrapper = styled.div`
  max-width: 1440px;
  margin: auto;
  display: grid;
  grid-template-columns: 50% 40%;
  justify-content: space-between;
  img {
    width: 100%;
  }
  div:nth-of-type(1) {
    padding-left: 5rem;
  }

  div:nth-of-type(1) h2 {
    padding-top: 3rem;
    font-size: 2rem;
    color: ${({ theme }) => theme.colors.body};
  }
  div:nth-of-type(1) p {
    font-size: 1.25rem;
  }
  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    gap: 4rem;
    div:nth-of-type(1) {
      background-image: url("https://res.cloudinary.com/dvwbbiu0g/image/upload/v1652354152/invest-trust/white_shield_logo_gqwkdp.png");
      background-position: center;
      background-repeat: no-repeat;
      padding-left: 5rem;
    }

    div:nth-of-type(1) h2 {
      width: 90%;
      margin: auto;
      padding-top: 3rem;
      font-size: 2rem;
      text-align: center;
      color: ${({ theme }) => theme.colors.body};
    }
    div:nth-of-type(1) p {
      font-size: 1.25rem;
      width: 82%;
      text-align: center;
      //   margin: auto;
    }
    div:nth-of-type(2) {
      margin-right: 5rem;
      margin-left: 5rem;
      padding-bottom: 4rem;
    }
  }
  @media screen and (max-width: 579px) {
    gap: 4rem;
    div:nth-of-type(1) {
      padding-left: 2rem;
    }

    div:nth-of-type(1) h2 {
      // border: 6px solid teal;
      width: 90%;
      //   margin: auto;
      text-align: center;
      padding-top: 3rem;
      font-size: 2rem;
      color: ${({ theme }) => theme.colors.body};
    }
    div:nth-of-type(1) p {
      font-size: 1.25rem;
      width: 92%;
    }
    div:nth-of-type(2) {
      margin-right: 1rem;
      margin-left: 1rem;
      padding-bottom: 4rem;
    }
  }
`;
export const DownloadBtn = styled(Button)`
    background-color: #DBDBF9;
`